import React from 'react';
import { PenTool, IdCard, TicketPercent, Gift, Printer, Sparkles } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import './style.css';
import logo1 from '../../img/brand/Logo_1.webp';
import logo2 from '../../img/brand/logo_2.webp';
import card1 from '../../img/brand/card-1.webp';
import card2 from '../../img/brand/card-2.webp';
import card3 from '../../img/brand/card-3.webp';
import card4 from '../../img/brand/card-4.webp';
import flyer1 from '../../img/brand/flyer-1.webp';
import gift1 from '../../img/brand/gift-1.webp';
import gift2 from '../../img/brand/gift-2.webp';
import gift3 from '../../img/brand/gift-3.webp';

const ICON_MAP = {
  logo: PenTool,
  card: IdCard,
  flyer: TicketPercent,
  gift: Gift,
};

const DELIVERABLE_ICONS = [Sparkles, PenTool, Printer];

const MOCKUPS = {
  logo:  [{ src: logo1, key: 'logo1' }, { src: logo2, key: 'logo2' }],
  card:  [{ src: card1, key: 'card1' }, { src: card2, key: 'card2' }, { src: card3, key: 'card3' }, { src: card4, key: 'card4' }],
  flyer: [{ src: flyer1, key: 'flyer1' }, { src: flyer1, key: 'flyer1' }],
  gift:  [{ src: gift1, key: 'gift1' }, { src: gift2, key: 'gift2' }, { src: gift3, key: 'gift3' }],
};

const KINDS = ['logo', 'card', 'flyer', 'gift'];

const Deliverables = ({ t }) => {
  const deliverables = t('deliverables', { returnObjects: true });
  return (
    <ul className="starter-deliverables">
      {deliverables.map(({ text }, i) => {
        const Icon = DELIVERABLE_ICONS[i];
        return (
          <li key={i} className="starter-deliverable">
            <span className="starter-deliverable__icon"><Icon size={18} /></span>
            <span>{text}</span>
          </li>
        );
      })}
    </ul>
  );
};

const GalleryStrip = ({ mockups, altMap }) => (
  <div className="starter-strip" role="list">
    {mockups.map(({ src, key }, i) => (
      <figure className="starter-shot" role="listitem" key={`${key}-${i}`}>
        <div className="starter-shot__frame">
          <img src={src} alt={altMap[key]} loading="lazy" />
        </div>
        <figcaption className="starter-shot__caption">{altMap[key]}</figcaption>
      </figure>
    ))}
  </div>
);

const PackCard = ({ kind, t }) => {
  const Icon = ICON_MAP[kind];
  const item = t(`items.${kind}`, { returnObjects: true });
  const altMap = t('mockups', { returnObjects: true });

  return (
    <article className="starter-card">
      <header className="starter-card__head">
        <div className="starter-card__icon"><Icon size={22} /></div>
        <h3 className="starter-card__title">{item.title}</h3>
        <span className="starter-card__tag">{item.tag}</span>
      </header>
      <GalleryStrip mockups={MOCKUPS[kind]} altMap={altMap} />
      <ul className="starter-card__bullets">
        {item.bullets.map((b) => <li key={b}>{b}</li>)}
      </ul>
    </article>
  );
};

const StarterBrandShowcase = () => {
  const { t } = useTranslation('brand');

  return (
    <section className="section starter-section">
      <div className="container">
        <header className="starter-header">
          <div className="tag__subtitle">{t('header.subtitle')}</div>
          <h2 className="title-2">
            {t('header.titleBefore')} <span className="accent">{t('header.titleAccent')}</span>
          </h2>
          <p className="starter-desc">{t('header.desc')}</p>
          <Deliverables t={t} />
        </header>

        <div className="starter-grid">
          {KINDS.map((kind) => <PackCard key={kind} kind={kind} t={t} />)}
        </div>

        <div className="starter-cta">
          <a className="button" href="/package/easy-start-package">
            {t('cta.primary')}
          </a>
          <a className="button" href="/contact">
            {t('cta.secondary')}
          </a>
        </div>
      </div>
    </section>
  );
};

export default StarterBrandShowcase;